export default {
    props: {
        type: String,
        dashType: String,
        data: Array,
        explodeField: String,
        currentField: String,
        targetField: String,
        field: String,
        name: String,
        highlightBorderWidth: {
            type: Number,
            kComposite: 'highlight.border.width'
        },
        highlightBorderColor: {
            type: String,
            kComposite: 'highlight.border.color'
        },
        highlightBorderOpacity: {
            type: Number,
            kComposite: 'highlight.border.opacity'
        },
        highlightColor: {
            type: String,
            kComposite: 'highlight.color'
        },
        highlightOpacity: {
            type: Number,
            kComposite: 'highlight.opacity'
        },
        highlightVisible: {
            type: Boolean,
            kComposite: 'highlight.visible'
        },
        aggregate: String | Function,
        axis: String,
        borderColor: { type: String | Function, kComposite: 'border.color' },
        borderDashType: { type: String | Function, kComposite: 'border.dashType' },
        borderOpacity: { type: Number | Function, kComposite: 'border.opacity' },
        borderWidth: { type: Number | Function, kComposite: 'border.width' },
        categoryField: String,
        color: String | Function,
        colorField: String,
        connectorsColor: { type: String, kComposite: 'connectors.color' },
        connectorsPadding: { type: Number, kComposite: 'connectors.padding' },
        connectorsWidth: { type: Number, kComposite: 'connectors.width' },
        gap: Number,
        labelsAlign: { type: String, kComposite: 'labels.align' },
        labelsBackground: { type: String | Function, kComposite: 'labels.background' },
        labelsBorderColor: { type: String | Function, kComposite: 'labels.border.color' },
        labelsBorderDashType: { type: String | Function, kComposite: 'labels.border.dashType' },
        labelsBorderWidth: { type: Number | Function, kComposite: 'labels.border.width' },
        labelsColor: { type: String | Function, kComposite: 'labels.color' },
        labelsDistance: { type: Number, kComposite: 'labels.distance' },
        labelsFont: { type: String | Function, kComposite: 'labels.font' },
        labelsFormat: { type: String | Function, kComposite: 'labels.format' },
        labelsMargin: { type: Number | Object, kComposite: 'labels.margin' },
        labelsPadding: { type: Number | Object, kComposite: 'labels.padding' },
        labelsPosition: { type: String | Function, kComposite: 'labels.position' },
        labelsTemplate: { type: String | Function, kComposite: 'labels.template' },
        labelsVisible: { type: Boolean | Function, kComposite: 'labels.visible' },
        line: String,
        lineColor: { type: String, kComposite: 'line.color' },
        lineOpacity: { type: Number, kComposite: 'line.opacity' },
        lineWidth: { type: String, kComposite: 'line.width' },
        lineStyle: { type: String, kComposite: 'line.style' },
        markersBackground: { type: String | Function, kComposite: 'markers.background' },
        markersBorder: { type: Function, kComposite: 'markers.border' },
        markersBorderColor: { type: String | Function, kComposite: 'markers.border.color' },
        markersBorderWidth: { type: Number | Function, kComposite: 'markers.border.width' },
        markersSize: { type: Number | Function, kComposite: 'markers.size' },
        markersType: { type: String | Function, kComposite: 'markers.type' },
        markersVisible: { type: Boolean | Function, kComposite: 'markers.visible' },
        markersRotation: { type: Number | Function, kComposite: 'markers.rotation' },
        missingValues: String,
        kStyle: String,
        negativeColor: String,
        opacity: Number,
        overlayGradient: { type: String, kComposite: 'overlay.gradient' },
        padding: Number,
        size: Number,
        startAngle: Number,
        spacing: Number,
        stack: Boolean | String,
        stackType: { type: String, kComposite: 'stack.type' },
        stackGroup: { type: String, kComposite: 'stack.group' },
        tooltipBackground: { type: String, kComposite: 'tooltip.background' },
        tooltipBorderColor: { type: String, kComposite: 'tooltip.border.color' },
        tooltipBorderWidth: { type: Number, kComposite: 'tooltip.border.width' },
        tooltipColor: { type: String, kComposite: 'tooltip.color' },
        tooltipFont: { type: String, kComposite: 'tooltip.font' },
        tooltipFormat: { type: String, kComposite: 'tooltip.format' },
        tooltipPadding: { type: Number | Object, kComposite: 'tooltip.padding' },
        tooltipTemplate: { type: String | Function, kComposite: 'tooltip.template' },
        tooltipVisible: { type: Boolean, kComposite: 'tooltip.visible' },
        width: Number,
        targetLineWidth: { type: Object | Function, kComposite: 'target.line.width' },
        targetColor: { type: String | Function, kComposite: 'target.color' },
        targetBorder: { type: Function, kComposite: 'target.border' },
        targetBorderColor: { type: String | Function, kComposite: 'target.border.color' },
        targetBorderDashType: { type: String | Function, kComposite: 'target.border.dashType' },
        targetBorderWidth: { type: Number, kComposite: 'target.border.width' },
        notesPosition: { type: String, kComposite: 'notes.position' },
        notesIconBackground: { type: String, kComposite: 'notes.icon.background' },
        notesIconBorderColor: { type: String, kComposite: 'notes.icon.border.color' },
        notesIconBorderWidth: { type: Number, kComposite: 'notes.icon.border.width' },
        notesIconSize: { type: Number, kComposite: 'notes.icon.size' },
        notesIconType: { type: String, kComposite: 'notes.icon.type' },
        notesIconVisible: { type: Boolean, kComposite: 'notes.icon.visible' },
        notesLabelBackground: { type: String, kComposite: 'notes.label.background' },
        notesLabelBorderColor: { type: String, kComposite: 'notes.label.border.color' },
        notesLabelBorderDashType: { type: String, kComposite: 'notes.label.border.dashType' },
        notesLabelBorderWidth: { type: Number, kComposite: 'notes.label.border.width' },
        notesLabelColor: { type: String, kComposite: 'notes.label.color' },
        notesLabelFont: { type: String, kComposite: 'notes.label.font' },
        notesLabelTemplate: { type: String | Function, kComposite: 'notes.label.template' },
        notesLabelVisible: { type: Boolean, kComposite: 'notes.label.visible' },
        notesLabelRotation: { type: Number, kComposite: 'notes.label.rotation' },
        notesLabelFormat: { type: String, kComposite: 'notes.label.format' },
        notesLabelPosition: { type: String, kComposite: 'notes.label.position' },
        notesLineWidth: { type: Number, kComposite: 'notes.line.width' },
        notesLineColor: { type: String, kComposite: 'notes.line.color' },
        notesLineLength: { type: Number, kComposite: 'notes.line.length' },
        zIndex: Number
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/SeriesProps.js